import { render, staticRenderFns } from "./SimpleColorPicker.vue?vue&type=template&id=cf3f764a"
import script from "./SimpleColorPicker.vue?vue&type=script&lang=js"
export * from "./SimpleColorPicker.vue?vue&type=script&lang=js"
import style0 from "./SimpleColorPicker.vue?vue&type=style&index=0&id=cf3f764a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports